/**
 * 省市
 */

 import {
    get,
    post,
    put,
    del
  } from '@/util/request'

  /**
   * 根据Id查询
   * @param {*} Id
   * @returns
   */
  export const SelectDministrativeDivisionsById = (Id) => {
    return get('/api/app/DministrativeDivisions?CurrentId=' + Id);
  }

  /**
   * 新增数据记录
   * @param {*} data
   * @returns
   */
  export const AddDministrativeDivisions = (data) => {
    return post('/api/app/DministrativeDivisions', data, {});
  }

  /**
   * 更新数据记录
   * @param {*} data
   * @returns
   */
  export const ModifyDministrativeDivisions = (data) => {
    return put('/api/app/DministrativeDivisions', data, {});
  }

  /**
   * 分页获取
   * @param {*} data
   * @returns
   */
  export const GetDataDministrativeDivisionsList = (data) => {
    return post('/api/app/DministrativeDivisions/list', data, {});
  }

  /**
   * 删除记录
   * @param {*} id
   * @returns
   */
  export const DeleteDministrativeDivisions = (id) => {
    return del('/api/app/DministrativeDivisions/' + id, {}, {});
  }